// Rinnova hero slideshow — self-contained custom element.
// Cross-fades slides, builds progress dots, autoplays, and stays editor-aware.
class RinnovaHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-rinnova-hero-slide]'));
    this.dotsHost = this.querySelector('[ref="dots"]');
    this.index = 0;
    this.timer = null;
    this.autoplay = parseInt(this.dataset.autoplay, 10) || 6000;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length === 0) return;

    this.buildDots();
    this.goTo(0, false);

    if (this.slides.length > 1 && !this.reduceMotion) {
      this.start();
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    // Theme editor: reveal the slide a merchant is editing.
    this.addEventListener('shopify:block:select', this.onBlockSelect);
    this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  buildDots() {
    if (!this.dotsHost || this.slides.length < 2) return;
    this.dotsHost.innerHTML = '';
    this.dots = this.slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'rinnova-hero__dot';
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Slide ${i + 1}`);
      dot.addEventListener('click', () => {
        this.goTo(i, false);
        if (!this.reduceMotion) this.start();
      });
      this.dotsHost.appendChild(dot);
      return dot;
    });
  }

  goTo(i, _fromTimer) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, idx) => {
      const active = idx === this.index;
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
    if (this.dots) {
      this.dots.forEach((dot, idx) => {
        // Re-add the class to restart the fill animation on the active dot.
        dot.classList.remove('is-active');
        if (idx === this.index) {
          void dot.offsetWidth;
          dot.classList.add('is-active');
        }
        dot.setAttribute('aria-selected', idx === this.index ? 'true' : 'false');
      });
    }
  }

  next = () => this.goTo(this.index + 1, true);

  start() {
    this.stop();
    if (this.slides.length < 2) return;
    this.timer = window.setInterval(this.next, this.autoplay);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  onVisibility = () => {
    if (document.hidden) {
      this.stop();
    } else if (!this.reduceMotion && this.slides.length > 1) {
      this.start();
    }
  };

  onBlockSelect = (event) => {
    const i = this.slides.indexOf(event.target);
    if (i >= 0) this.goTo(i, false);
    this.stop();
  };

  onBlockDeselect = () => {
    if (!this.reduceMotion && this.slides.length > 1) this.start();
  };
}

if (!customElements.get('rinnova-hero')) {
  customElements.define('rinnova-hero', RinnovaHero);
}
